import React from "react";
import { Text } from "@gusarov-studio/rubik-ui";
import { MarkdownContent } from "../../../../common/components/MarkdownContent/MarkdownContent";

interface ToolCallPayloadProps {
  label: string;
  /** Pretty-printed JSON (or plain text for errors) shown as a Streamdown code block. */
  value: string;
  variant?: "default" | "danger";
}

/** Wrap `value` in a fenced JSON code block Streamdown / Shiki can highlight. */
function toJsonMarkdown(value: string): string {
  // Neutralize any triple-backtick runs so a payload can't close the fence early.
  const safe = value.replaceAll("```", "``\u200b`");
  return `\`\`\`json\n${safe}\n\`\`\``;
}

/**
 * One labelled block inside a `ToolCall` — the arguments the model sent, what
 * the tool returned, or the error it threw. Uses Streamdown's Shiki code block
 * (same look as markdown JSON in the app) instead of Monaco for cost.
 */
const ToolCallPayload: React.FC<ToolCallPayloadProps> = ({ label, value, variant = "default" }) => {
  "use memo";

  return (
    <div className="flex flex-col gap-1">
      <Text
        size="12"
        color={variant === "danger" ? "danger" : "muted"}
        weight="500"
      >
        {label}
      </Text>
      {/* key: Streamdown memoizes code fences by AST position, not content */}
      <MarkdownContent key={value}>{toJsonMarkdown(value)}</MarkdownContent>
    </div>
  );
};

export { ToolCallPayload };
